<template>


  <div class="wrapper signup-page-wrp">


    <div class="signup-page signin-page">
      <div class="signup-page-left" :class="{'ptclBgLeftSide':isReferBy==true}">
        <div class="align">
          <div class="logo"><a href="javascrpt:void(0)"><img
            :src="require('@/assets/images/CleverStaff_Signin_Logo .svg')" width="222" height="152"
            alt="CleverStaff-logo"></a></div>
          <br>
          <img v-if="isReferBy"
               :src="require('@/assets/images/ptcl-group.png')"
               width="193"
               alt="Logo"
          />
        </div>
      </div>
      <div class="signup-page-right">
        <div class="align">
          <form class="signin-form" @submit.prevent="login()">
            <div class="signin-top">
              <span class="text-primary">Don't have an account?</span>
              <router-link :to="referByUrl">
                <span class="btn btn-lg btn-outline-primary">Sign Up</span>
              </router-link>
            </div>
            <div class="tab-content ">
              <div role="tabpanel" class="tab-pane active" id="manager">
                <div class="tab-heading">
                  <h1>Sign in </h1>
                </div>
                <div class="tab-form">
                  <div class="form-group">
                    <label>Email</label>
                    <div class="input-wrapper wrap4">
                      <i class="ico ico-email"></i>
                      <input type="email" autocomplete="off" class="form-control form-control-lg"
                             id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="" v-model="form.email"
                             @change="validateInput('email')">
                    </div>
                    <p class="mt-5" v-if="validity.email === 'invalid'"
                       :class="{textRed : validity.email === 'invalid'}">Enter valid email</p>
                    <p v-text="errorMessageEmail" class="text-danger">sad</p>
                  </div>
                  <div class="form-group mb-0">
                    <label><span>Password</span></label>
                    <div class="input-wrapper wrap3">
                      <i class="ico ico-lock"></i>
                      <input type="password" name="password" autocomplete="off"
                             class="form-control form-control-lg mb-0" id="signin-password" aria-describedby="emailHelp"
                             placeholder="" v-model="form.password" @change="validateInput('password')">
                      <i class="ico-sec ico-eye_selected em-pass"></i>
                    </div>
                    <p class="mt-5" v-if="validity.password === 'invalid'"
                       :class="{textRed : validity.password === 'invalid'}">Enter valid password</p>
                  </div>
                  <p v-text="errorMessage1" class="text-danger">sad</p>
                  <p v-text="errorMessage" class="text-danger">sad</p>
                  <div class="forgot-btn text-right">
                    <router-link to="/forgot-password">
                      Forgot Password?
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-foot text-center">
              <button class="btn btn-lg btn-outline-primary">
                <clip-loader :loading="loading" :size="size" :color="spinnerColor"></clip-loader>
                Sign In
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>


</template>
<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  name: 'login',

  components: {ClipLoader},

  data() {
    return {
      form: {
        email: null,
        password: null,
        type: ['MANAGER','EMPLOYEE'],
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        fcm_token: 'web'
      },
      validity: {
        email: '',
        password: '',
      },
      errorMessage: '',
      errorMessage1: '',
      errorMessageEmail: '',
      loading: false,
      size: '25px',
      referBy: this.$route.query.refer,
      isReferBy: false,
      spinnerColor: '#75868D',
      referByUrl: 'signup',
    }
  },
  created() {
    if (this.referBy !== '' && this.referBy !== undefined) {
      this.referByUrl= 'signup?tok=%242y%2410%24g2JfOWb29IBR7maEAX8HuW5F5qV8UFqU3yp4G4pTaD41lzAbfYve%242y%2410%24g2JfOWb29IBR7maEAX8HuW5F5qV8UFqU3yp4G4pTaD41lzAbfYve&refer=ptcl',
      this.isReferBy = true;
    }
  },
  methods: {
    login() {
      if (this.validateInput()) {
        this.loading = true
        this.$axios
        .post(this.$Login, $.param(this.form))
        .then(response => {
          if (response.data.status === 200) {
            this.loading = true
            let user = response.data.result.user;
            this.$store.commit('setUser', user);
            this.$store.commit('setLoginInProfile', user );
              localStorage.setItem('isLogin', 1);
              if (user.is_leave_access == 1) {
                this.$router.push({name: 'leaves'});
              } else if(user.type==='MANAGER') {
                this.$router.push({name: 'dashboard'});
              }else if(user.type==='EMPLOYEE') {
                this.$router.push({path: '/attendance/punchin'});
              }
              //this.$router.go()
            } else if (response.data.status === 502) {
              $root.$toast.error(response.data.message);
              this.loading = true
              this.errorMessage = response.data.message;
              let user = response.data.result.user;
              localStorage.setItem('isLogin', 1);
              this.$store.commit('setUser', user);
              this.verifyCode();
            } else if (response.data.message == 'The password field is required.') {
              this.errorMessage1 = response.data.message;
              this.errorMessageEmail = ''
            } else if (response.data.message == 'Email does not exist!') {
              this.errorMessageEmail = response.data.message;
              this.errorMessage1 = ''
            } else if (response.data.message == 'Invalid Password!') {
              this.errorMessageEmail = ''
              this.errorMessage1 = response.data.message
            } else if (response.data.status === 402) {
              $root.$toast.error("You can not login as employee");
            }
            this.loading = false
          })
          .catch(error => {
            this.loading = false
          })
      }

    },
    verifyCode() {
      this.$router.push({name: 'verifyCode'});
    },
    validateInput(fieldname = '') {
      if (fieldname === 'email' || fieldname === '') {
        var re = /\S+@\S+\.\S+/;
        if (this.form.email === '' || !re.test(this.form.email)) {
          this.validity.email = 'invalid'
        } else {
          this.validity.email = ''
        }
      }
      if (fieldname === 'password' || fieldname === '') {
        if (this.form.password === '') {
          this.validity.password = 'invalid'
        } else {
          this.validity.password = ''
        }
      }
      if (this.validity.email == '' && this.validity.password == '') {
        return true
      } else {
        return false
      }
    },
  }
}
</script>
<style scoped>
.textRed {
  color: red;
}

.borderRed {
  border: solid red;
}


.tab-foot .spinner-border {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.v-spinner {
  text-align: center;
  display: inline;
}
.ptclBgLeftSide{
  background: linear-gradient(to right, rgba(139, 184, 39, 1) 0%, rgba(0, 125, 66, 1) 100%) !important;
}
</style>

